import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';


const boApiCaller: AxiosInstance = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL_YP,
    headers: {
        'Content-Type': 'application/json',
    },
});

boApiCaller.interceptors.response.use(
    (response: AxiosResponse) => {
        return response;
    },
    (error: AxiosError) => {
        if (error.response) {
            console.error('API Error:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Request setup error:', error.message);
        }
        return Promise.reject(error);
    }
);

export default boApiCaller;